import { useBranding } from '@/hooks/useBranding';
import { NotificationsPanel } from './NotificationsPanel';

interface HeaderProps {
  user?: { id: string; email: string } | null;
  onLogout?: () => void;
  adminViewMode?: 'admin' | 'user';
}

export function Header({ user, onLogout, adminViewMode }: HeaderProps) {
  const { branding } = useBranding();

  return (
    <header className="glass-strong sticky top-0 z-50">
      {adminViewMode === 'user' && (
        <div className="bg-amber-500/15 border-b border-amber-500/30 px-4 py-1.5 text-center">
          <span className="text-xs text-amber-300 font-medium">
            Viewing as User — Admin features hidden
          </span>
        </div>
      )}
      <div className="px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo / Brand */}
          <div className="flex items-center gap-3">
            <img
              src={branding.logoUrl}
              alt={branding.appName}
              className="w-10 h-10 rounded-xl shadow-glow object-contain"
              onError={(e) => {
                // Fallback to default favicon if load fails
                e.currentTarget.src = '/favicon.svg';
              }}
            />
            <div>
              <h1 className="text-xl font-bold text-royal-gradient font-heading">
                {branding.appName}
              </h1>
              <p className="text-xs text-slate-500">{branding.tagline}</p>
            </div>
          </div>

          {/* User Info */}
          <div className="flex items-center gap-4">
            {/* Notifications */}
            {user && <NotificationsPanel />}

            <span className="text-sm text-slate-400 hidden sm:block">
              {user?.email || 'demo@levelupcoach.app'}
            </span>
            {onLogout && (
              <button
                onClick={onLogout}
                className="px-3 py-1.5 text-sm text-slate-400 hover:text-white
                         bg-charcoal-800 hover:bg-charcoal-700 rounded-lg
                         transition-colors duration-200"
              >
                Sign Out
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
